export default {
  files: state => bucket => {
    return state.files[bucket];
  }
};